// Serializes structured data for a <script type="application/ld+json"> tag
// via dangerouslySetInnerHTML. Plain JSON.stringify() is not safe here: if
// the data includes a string containing "</script>" (e.g. a facility's own
// free-text description), the HTML parser closes the script tag early and
// whatever follows renders as live markup - a stored-XSS path for any field
// that ultimately traces back to user-entered text. Escaping "<" as its
// unicode escape prevents that while remaining valid JSON.
export const toSafeJsonLdString = (data) => JSON.stringify(data).replace(/</g, '\\u003c');
